<template>
    <fieldset style="margin-bottom: 20px;" class="reviewCommentTableCell">
        <DeclineDialog ref="dialog" :comment-id="item.id" @declined="updateTable" />
        <legend>
            <a :href="`${urlsFrontend}/${item.reviewee.city}/${item.reviewee.type.toLowerCase()}/${item.reviewee.url}`"
               target="_blank"
               v-tooltip="`${urlsFrontend}<br/>/${item.reviewee.city}/${item.reviewee.type.toLowerCase()}/${item.reviewee.url}`">
                <text-highlight :queries="searchRevieweeName">
                    {{item.reviewee.name}}
                </text-highlight>
            </a>
        </legend>

        <table class="grid">
            <tr>
                <td>
                    <span class="comma">
                        {{ item.reviewee.info_title }}
                    </span>
                    <br>
                    <b style="font-size: 16px;">{{ authorName }}</b>
                </td>
                <td style="text-align: right; width: 100px">
                    <b style="white-space: nowrap;">{{ item.created_at | formatDate }}</b>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <div class="textareaMarkable">
                        <textarea v-model="item.text" class="review-comment-text"/>
                    </div>
                </td>
            </tr>
            <tr v-if="item.moderated_at && !item.published">
                <td>
                    <strong>причина: {{ item.reject_reason }}</strong>
                </td>
            </tr>
            <tr>
                <td>
                    <div v-if="item.moderated_at != null">
                        <small style="white-space: nowrap">
                            Проверено: <b>{{ item.moderated_at | formatDateTime }}</b>
                        </small>
                        <br>
                        <small style="white-space: nowrap">
                            Проверил: <b>{{ item.moderator.fio }}</b>
                        </small>
                    </div>
                </td>
                <td>
                    <div class="controls" style="float: right; white-space: nowrap">
                        <v-loading-component v-if="status !== 'new'" @click="update">
                            <template slot-scope="{ loadingClass }">
                                <button :class="['blueHover noOutline', loadingClass]">Сохранить</button>
                            </template>
                        </v-loading-component>
                        <v-loading-component v-if="status !== 'published'" @click="publish">
                            <template slot-scope="{ loadingClass }">
                                <button :class="['greenHover noOutline', loadingClass]">Публиковать</button>
                            </template>
                        </v-loading-component>
                        <v-loading-component v-if="status !== 'unpublished'" @click="decline">
                            <template slot-scope="{ loadingClass }">
                                <button :class="['redHover noOutline', loadingClass]">
                                    {{ status  === 'new' ? 'Не публиковать' : 'Отменить публикацию' }}
                                </button>
                            </template>
                        </v-loading-component>

                        <v-loading-component @click="deleteRow(item, $event)">
                            <template slot-scope="{ loadingClass }">
                                <button :class="['redHover noOutline', loadingClass]">Удалить</button>
                            </template>
                        </v-loading-component>
                    </div>
                </td>
            </tr>
        </table>
    </fieldset>
</template>

<script>
import DeclineDialog from "./DeclineDialog";
import TextHighlight from "vue-text-highlight";
export default {
    components: {DeclineDialog, TextHighlight},
    props: {
        status: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        },
        urlsFrontend: {
            type: String,
            required: true
        },
    },
    methods: {
        decline() {
            this.$refs.dialog.$refs.dialog.show()
        },
        deleteRow: function (comment, btn) {
            this.$modal('Удалить?', {
                name: 'Да',
                callback: () => {
                    this.actionRequest('delete', btn);
                }
            });
        },
        publish: function (btn) {
            this.actionRequest('publish', btn);
        },
        update: function (btn) {
            this.actionRequest('update', btn);
        },
        actionRequest: function (action, btn) {
            btn.startLoadingAnimation();

            return this.axios.post('reviewComments/' + action + '/' + this.item.id, this.item).then(() => {
                btn.stopLoadingAnimation();
                this.updateTable();
            }).catch(() => btn.stopLoadingAnimation());
        },
        updateTable: function () {
            this.$emit('update-table');
            this.$bus.fire('updateMenu');
        },
    },
    computed: {
        authorName() {
            switch (this.item.author_type) {
                case 'DOCTOR_SITE':
                    return 'Врач';
                case 'PATIENT':
                    return 'Пациент';
                case 'CLINIC':
                    return 'Клиника';
                case 'NETWORK':
                    return 'Сеть';
            }
        },
        searchRevieweeName() {
            if (this.$parent.$parent.$parent.filter.reviewee_name) {
                return this.$parent.$parent.$parent.filter.reviewee_name.split(' ');
            }

            return '';
        },
    },
}
</script>

<style scoped>
.reviewCommentTableCell mark.text__highlight {
    background: #ff0;
}

.reviewCommentTableCell button.noOutline:active {
    border-color: #8b8b8b !important;
}

.reviewCommentTableCell button.noOutline:focus {
    border-color: #ddd !important;
}
</style>
